import React from "react";
import {useTranslation} from "react-i18next";
import {PrimaryButton} from "./PrimaryButton";
import AddIcon from "@mui/icons-material/Add";
import {SxProps} from "@mui/system";
import {Theme} from "@mui/material/styles";

export function AddButton(props: {
  onClick: () => void,
  title?: string,
  sx?: SxProps<Theme>,
}) {
  const {t} = useTranslation();
  return (
    <PrimaryButton sx={props.sx} onClick={props.onClick} title={props.title || t('buttons.create')} startIcon={<AddIcon/>}/>
  )
}
